/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export default class ScopedTabbedView extends React.Component {
  static propTypes = {
    tabsLabel: PropTypes.string,
    tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
    contents: PropTypes.arrayOf(PropTypes.any).isRequired,
    onClick: PropTypes.func,
    initialActiveTabIndex: PropTypes.number
  }

  state = {
    activeTabIndex: this.props.initialActiveTabIndex
      ? this.props.initialActiveTabIndex
      : 0
  }

  handleTabClick = (tabIndex) => {
    this.setState({ activeTabIndex: tabIndex }, () => {
      if (this.props.onClick) {
        this.props.onClick(tabIndex)
      }
    })
  }

  indexMatchesActiveTab = (tabIndex) => (
    this.state.activeTabIndex === tabIndex
  )

  getTabs = () => (
    this.props.tabs.map((tab, index) => (
      <Tab
        title={tab}
        selected={this.indexMatchesActiveTab(index)}
        index={index}
        onClick={this.handleTabClick}
        key={`scopedtab_${index}`}
      />
    ))
  )

  getContents = () => (
    this.props.contents.map((content, index) => (
      <Content
        tabIndex={index}
        show={this.indexMatchesActiveTab(index)}
        key={`scopedtab_content_${index}`}>
        {content}
      </Content>
    ))
  )

  render() {
    let tabs = this.getTabs()
    let contents = this.getContents()

    return (
      <div className='slds-tabs_scoped'>
        {this.props.tabsLabel
          ? <div className='slds-grid'  style={{ alignItems: 'center' }}>
              <div className='slds-text-title_caps slds-m-left_medium slds-m-right_small'>
                <b>{`${this.props.tabsLabel}:`}</b>
              </div>
              <ul className='slds-tabs_scoped__nav' role='tablist'>
                {tabs}
              </ul>
            </div>
          : <ul className='slds-tabs_scoped__nav' role='tablist'>
              {tabs}
            </ul>
        }
        {contents}
      </div>
    )
  }
}

const Tab = ({ title, selected, index, onClick }) => (
  <li className={`slds-tabs_scoped__item${selected ? ' slds-is-active' : ''}`} title={title} role='presentation'>
    <a
      className='slds-tabs_scoped__link'
      role='tab'
      tabIndex={selected ? '0' : '-1'}
      aria-selected={selected}
      aria-controls={`tab-scoped-${index}`}
      id={`tab-scoped-${index}__item`}
      onClick={() => onClick(index)}>
      {title}
    </a>
  </li>
)

Tab.propTypes = {
  title: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired
}

Tab.defaultProps = {
  selected: false
}

const Content = ({ children, tabIndex, show }) => (
  <div
    id={`tab-scoped-${tabIndex}`}
    className={`slds-tabs_scoped__content ${show ? 'slds-show' : 'slds-hide'}`}
    role='tabpanel'
    aria-labelledby={`tab-scoped-${tabIndex}__item`}
    style={{ padding: 0 }}>
    {children}
  </div>
)

Content.propTypes = {
  children: PropTypes.any.isRequired,
  tabIndex: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/scoped-tabbed-view/index.js